module.exports = __webpack_public_path__ + "static/media/buildingConstruction4.dd712f77.jpg";